import { ProductPrice } from '@components/Product/ReflectionCard'
import { ProductPriceRangeFragment } from '@graphql/fragments/__generated__/ProductPriceRange.generated'
import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { Link } from 'react-router-dom'
import PlaceHolder from '../../../../../../images/placeholder-img.svg'

export interface ISecondLevelProduct {
  id: string | number
  name: string
  image: string
  pathname: string
  placeholderPaddingBottom?: string | number
  priceRange?: ProductPriceRangeFragment
}
export interface ISecondLevelItem {
  id: string
  name: string
  pathname: string
  onClick(idx: number): void
  className?: string
  children?: ISecondLevelItem[]
  sales?: number[]
}

interface IMenuSecondLevelProps {
  items: ISecondLevelItem[]
  products?: ISecondLevelProduct[]
}

const MenuSecondLevel: React.FC<IMenuSecondLevelProps> = ({ items, products }) => {
  return (
    <>
      {items.map(item => {
        return (
          <div key={item.id} className='columnContainer'>
            <div className='category-child'>
              <Link
                aria-label={item.name}
                className='titleSubmenu'
                onClick={e => {
                  item.onClick(-1)
                }}
                to={item.pathname}
              >
                <span className={item.className}>{item.name}</span>
              </Link>
            </div>
            {item.children?.map(child => {
              return (
                <div className='subcategory-child' key={child.id}>
                  <Link
                    aria-label=''
                    onClick={e => {
                      item.onClick(-1)
                    }}
                    to={child.pathname}
                  >
                    <span className={child.className}>{child.name}</span>
                  </Link>
                </div>
              )
            })}
          </div>
        )
      })}
      {products?.map(p => {
        return (
          <div className='menu__img' key={p.id}>
            <Link to={p.pathname}>
              <div className='relative overflow-hidden'>
                <LazyLoadImage
                  alt={p.name}
                  className='w-full h-full object-cover'
                  wrapperClassName='absolute inset-0'
                  effect='opacity'
                  visibleByDefault
                  placeholderSrc={PlaceHolder}
                  src={p.image}
                />
                <div
                  style={{
                    paddingBottom: p.placeholderPaddingBottom || '125%',
                  }}
                />
              </div>

              <div className='titleProduct letterSpacingStd'>
                <div>{p.name}</div>
              </div>
              {p.priceRange && (
                <div className='text-center'>
                  <ProductPrice priceRange={p.priceRange} />
                </div>
              )}
            </Link>
          </div>
        )
      })}
    </>
  )
}

export default React.memo(MenuSecondLevel)
